import { Controller } from "@hotwired/stimulus";

// Realtime order Step 5 — "Where should your leads go?" (#17716). Two Choice
// Cards (real radios) pick which panel shows: GOAT CRM (features + Get GOAT
// CRM in a new tab) or My Own CRM (the agent's integration fields).
//
// Presentation only. Hiding a panel never disables, clears or unticks the
// controls inside it, so the order posts exactly the same integrations whichever
// card is selected (realtime-order#buildOrderFormData reads them by name, and
// never posts this radio — it is listed in HAND_BUILT_NAMES).
export default class extends Controller {
  static targets = ["radio", "card", "panel"];

  connect() {
    this.sync();
  }

  // change-> on either radio (click, label click or arrow keys).
  select() {
    this.sync();
  }

  sync() {
    const choice = this.radioTargets.find((radio) => radio.checked)?.value;
    if (!choice) return;

    this.cardTargets.forEach((card) => {
      card.classList.toggle("selected", card.dataset.choice === choice);
    });
    this.panelTargets.forEach((panel) => {
      panel.hidden = panel.dataset.choice !== choice;
    });
  }
}
